import * as React from 'react';
import { observer } from 'mobx-react';
import { autoinject } from '../Utils/AutoInject';

export interface IIconCardProps {
    readonly icon: React.ReactNode;
    readonly bgColor: 'purple' | 'pink' | 'yellow' | 'green' | 'blue';
    readonly customIcon?: React.ReactNode;
}

@autoinject
@observer
export class IconCard extends React.Component<IIconCardProps> {
    public render() {
        const { icon, children, bgColor, customIcon } = this.props;

        return (
            <div className="card icon-card h-100">
                <div className={`card-bg-${bgColor} card-body p-2 rounded`}>
                    <div className="row">
                        <div className="col-8">{children}</div>
                        <div className="col-4 d-flex">
                            <div className="ms-auto d-inline-block">
                                {!customIcon && <span className="f-24">{icon}</span>}

                                {customIcon}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export interface IIconCardItemProps {
    readonly title: string;
    readonly data?: React.ReactNode | string;
    readonly className?: string;
}

@autoinject
@observer
export class IconCardItem extends React.Component<IIconCardItemProps> {
    public render() {
        const { data, title, className } = this.props;

        return (
            <div className={className}>
                <div className="d-inline-block pr-1">{title}:</div>
                <div className="d-inline-block">{data || '-'}</div>
            </div>
        );
    }
}
